export const isNonEmptyArray = (value: any): boolean =>
    Array.isArray(value) && value.length > 0;

export const isValidDate = (value: any): boolean =>
    value instanceof Date && !Number.isNaN(value.getTime());

export const isFilledValue = (value: any): boolean =>
    value !== undefined && value !== null;
